import*as e from"react";const t=t=>{e.useEffect((()=>{const e=()=>{t()};return e(),window.addEventListener("resize",e),()=>window.removeEventListener("resize",e)}),[t])};export{t as default};
